exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact-detail-block[data-v-b30f81ca] {\n  background-color: #F1F1F1;\n  padding: 15px;\n  border-radius: 5px;\n  margin-top: 20px;\n}\n", ""]);

// exports
